<template functional>
  <picture
    :class="['Pic', data.class, data.staticClass]"
    v-on="listeners">
    <source
      v-for="([format, formatSrc, formatType]) in $options.sources(props)"
      :key="format"
      :srcset="formatSrc"
      :type="formatType">
    <img
      v-bind="data.attrs"
      :alt="props.alt"
      :src="$options.srcAbs(props.src)">
  </picture>
</template>

<script>
import { basePath } from '../../../config'

const formatTypes = {
  jpg: 'jpeg',
  svg: 'svg+xml',
}

function absoluteSourcePath(source) {
  if (source.startsWith('.')) {
    return require(`@/assets/${source.replace(/(\.\.?\/)+assets\//, '')}`)
  } else if (source.startsWith('/')) {
    return `${basePath}${source}`
  }

  return source
}

function getFormatAbsolutePath(relativePath, format) {
  return absoluteSourcePath(`${relativePath}.${format}`)
}

function formSource(relativePath, format) {
  return [
    format,
    getFormatAbsolutePath(relativePath, format),
    `image/${formatTypes[format] || format}`,
  ]
}

export default {
  props: {
    alt: String,
    formats: Array,
    src: String,
  },
  sources(props) {
    const pathWithoutFormat = [...props.src.split('.').slice(0, -1)].join('.')

    return [
      ...(props.formats || []),
      props.src.match(/\w*$/)[0],
    ].map(format => formSource(pathWithoutFormat, format))
  },
  srcAbs(source) {
    return absoluteSourcePath(source)
  },
}
</script>
